import React, { useMemo } from 'react';
import {
  KIDPLACE_PROVIDER,
  competitionSummaryForItems,
  providerColor,
} from '../utils/competition';

export default function CompetitionLegend({ items = [], scope = 'commune' }) {
  const summary = useMemo(() => competitionSummaryForItems(items, scope), [items, scope]);
  if (!summary.providers.length) {
    return (
      <div className="prospecting-competition-legend is-empty">
        <strong>Konkurencja</strong>
        <span>Brak znanych wdrożeń w widocznym zakresie</span>
      </div>
    );
  }

  return (
    <div className="prospecting-competition-legend" aria-label="Legenda konkurencji">
      <div className="prospecting-competition-legend-head">
        <strong>Konkurencja</strong>
        <span>{summary.known_units_count} znanych</span>
      </div>
      <div className="prospecting-competition-legend-items">
        {summary.providers.map(({ provider, count }) => (
          <div key={provider} className="prospecting-competition-legend-row">
            <i style={{ backgroundColor: providerColor(provider) }} aria-hidden="true" />
            <span>{provider === KIDPLACE_PROVIDER ? 'Kidplace · nasze' : provider}</span>
            <b>{count}</b>
          </div>
        ))}
      </div>
    </div>
  );
}
